// Utilities
import { make } from 'vuex-pathify'

const state = {
  showShareDialog: false,
  shareTitle: null,
  shareText: null,
  shareUrl: null,
}

const getters = {
  ...make.getters(state),
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
